module.exports = __webpack_public_path__ + "static/media/scratch.94941dc8.png";